<template>
<li>
    <a @click="toCatList(item.id)" href="#">
        <img :src="item.picture_url">
        <p><span><strong>{{ item.count }}</strong>件/套</span>{{ item.name }}</p>
        <i></i>
    </a>
</li>
</template>

<script>
export default {
  name: 'Category',
  props: {  // props接收父组件传递过来的数据
    item: {
      type: Object,
      default: function() {
        return []
      }
    }
  },
  methods: {
    toCatList(id) {  // 点击分类，跳转到分类的列表页
      this.$router.push({
          path: `/list/${id}`
      })
    }
  }
}
</script>